/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FetchData } from 'app/shared/generalMethods';
import { InputValidation } from 'app/shared/inputValidation';

import { AdminCommunityService } from 'app/services/admin-community.service';

@Component({
  selector: 'app-community-detail',
  templateUrl: './community-detail.component.html',
  styleUrls: ['./community-detail.component.scss']
})
export class CommunityDetailComponent implements OnInit {
  isEditMode = false;
  pageLoader = false;
  pageLoaderText = 'Loading...';
  communityForm: FormGroup;
  community: any;
  adminData: any;

  constructor(
    private _formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private _router: Router,
    private route: ActivatedRoute,
    private _fetchData: FetchData,
    private _inputValidation: InputValidation,
    private adminCommunityService: AdminCommunityService
  ) {}

  ngOnInit(): void {
    const communityId = this.route.snapshot.paramMap.get('id');
    this.loadCommunityData(communityId);
    this.initializeForm();
  }

  initializeForm(): void {
    this.communityForm = this._formBuilder.group({
      id: [''],
      name: ['', Validators.required],
      description: [''],
      location: ['', Validators.required],
      contactPhone: ['', Validators.required]
    });
  }

  loadCommunityData(communityId: string): void {
    this.adminData = this._fetchData.data.lstAdministratorData[0].Name;
    this.pageLoader = true;
    setTimeout(() => {
      this.community = this._fetchData.data?.lstLocations?.find(c => c.Id === communityId);
      if (this.community) {
        this.communityForm.patchValue({
          id: communityId,
          name: this.community.Name,
          description: this.community.Community_Description__c,
          location: this.community.Community_Location__c,
          contactPhone: this.community.Community_Phone__c
        });
      }
      this.pageLoader = false;
    }, 1000);
  }

  toggleEditMode(): void {
    this.isEditMode = !this.isEditMode;
    if (!this.isEditMode) {
      this.communityForm.patchValue({
        id: this.community.Id,
        name: this.community.Name,
        description: this.community.Community_Description__c,
        location: this.community.Community_Location__c,
        contactPhone: this.community.Community_Phone__c
      });
    } else {
      this.communityForm.patchValue({
        id: this.community.Id
      });
    }
  }

  onFormSubmit(): void {
    if (this.communityForm.invalid) {
      return;
    }

    this.pageLoader = true;
    this.pageLoaderText = 'Updating community...';
    const adminId = localStorage.getItem('adminId');

    // Transform form values to match API expected field names
    const payload = {
      communityid: this.communityForm.value.id,
      name: this.communityForm.value.name,
      description: this.communityForm.value.description,
      location: this.communityForm.value.location,
      contactPhone: this.communityForm.value.contactPhone,  // <<< mapping here
      adminIdOrUid: adminId
    };

    this.adminCommunityService.updateCommunity(payload, adminId).subscribe(
      (response) => {
        if (response && response.success) {
          this._fetchData.setLocalStorage(response.msg);
          this._snackBar.open('Admin profile updated successfully!', 'Close', {
            duration: 3000
          });

          this.isEditMode = false;
          this.pageLoader = false;

          this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigate(['/community-list']);
          });

        } else {
          this.pageLoader = false;
          this._snackBar.open('Failed to update admin profile!', 'Close', {
            duration: 3000
          });
        }
      },
      (error) => {
        this.pageLoader = false;
        this._snackBar.open('Error updating admin profile!', 'Close', {
          duration: 3000
        });
      }
    );
  }


  onFormSubmit1(): void {
    if (this.communityForm.invalid) {
      return;
    }

    this.pageLoader = true;
    this.pageLoaderText = 'Updating community...';
    const adminId = localStorage.getItem('adminId');
    this.pageLoader = true;
    this.pageLoaderText = 'Updating admin profile...';
    this.adminCommunityService.updateCommunity(this.communityForm.value, adminId).subscribe(
      (response) => {
        if (response && response.success) {
          this._fetchData.setLocalStorage(response.msg);
          this._snackBar.open('Admin profile updated successfully!', 'Close', {
            duration: 3000
          });

          this.isEditMode = false;
          this.pageLoader = false;

          this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigate(['/profile-detail']);
          });

        } else {
          this.pageLoader = false;
          this._snackBar.open('Failed to update admin profile!', 'Close', {
            duration: 3000
          });
        }
      },
      (error) => {
        this.pageLoader = false;
        this._snackBar.open('Error updating admin profile!', 'Close', {
          duration: 3000
        });
      }
    );
  }

}
